module.exports = "<div class=topbar> <div class=topbar-content> <a class=topbar-logo href=https://www.taelys.com> <img class=taelys-logo src=/images/logo_taelys.svg /> <h3 class=\"app-name no-print\">{{'topbar.appLabel.OBSERVATOIRE' | translate}}</h3> </a> <obs-taelys-incentive></obs-taelys-incentive> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/apps/observatoire/ng/structure/observatoireTopBar.html
// module id = 3583
// module chunks = 12